import {CopilotAvatar} from '@github-ui/copilot-avatar'
import {GitHubAvatar} from '@github-ui/github-avatar'
import {AvatarStack} from '@primer/react'

import type {User} from '../../../../api/common-contracts'
import {isCopilot} from '../../../../helpers/assignee-helper'
import {joinOxford} from '../../../../helpers/join-oxford'
import type {FieldAggregate} from '../../../../hooks/use-aggregation-settings'
import {AggregateLabels} from '../../aggregate-labels'
import {SanitizedGroupHeaderText} from '../sanitized-group-header-text'
import styles from './assignees-group-header-label.module.css'

type Props = {
  assignees: Array<User>
  rowCount: number
  hideItemsCount: boolean
  aggregates: Array<FieldAggregate>
  titleClassName?: string
}

export function AssigneesGroupHeaderLabel({assignees, rowCount, aggregates, hideItemsCount, titleClassName}: Props) {
  const title = joinOxford(assignees.map(u => u.login))

  return (
    <>
      <AvatarStack className={styles.AvatarStack}>
        {assignees.map(assignee =>
          isCopilot(assignee.login) ? (
            <CopilotAvatar key={assignee.id} />
          ) : (
            <GitHubAvatar loading="lazy" key={assignee.id} alt={assignee.login} src={assignee.avatarUrl} />
          ),
        )}
      </AvatarStack>
      <SanitizedGroupHeaderText titleHtml={title} className={titleClassName} />
      <AggregateLabels
        itemsCount={rowCount}
        aggregates={aggregates}
        hideItemsCount={hideItemsCount}
        counterClassName={styles.AggregateLabels}
      />
    </>
  )
}

try{ AssigneesGroupHeaderLabel.displayName ||= 'AssigneesGroupHeaderLabel' } catch {}